// apps/web/src/lib/permissoes-catalogo.ts — quick 261006-lf9.
// Rótulos e descrições pt-BR de TODAS as permissões concedíveis (PERMISSION_MATRIX
// da API), agrupadas por módulo. Fonte única para a matriz de permissões, o
// catálogo e a aba de pessoas. O teste de cobertura garante que nenhuma chave
// da matriz da API caia no texto genérico.

export const GRUPO_OUTRAS = 'Outras permissões';

export const ROTULOS_MODULO: Readonly<Record<string, string>> = {
  users: 'Usuários e perfis',
  apontamento: 'Apontamento no chão de fábrica',
  apontamentos: 'Apontamentos (gestão)',
  omie: 'Integração Omie',
  migracao: 'Migração de dados',
  producao: 'Produção',
  planejamento: 'Planejamento',
  kanban: 'Kanban',
  qualidade: 'Qualidade',
  remessas: 'Remessas',
  cadastros: 'Cadastros',
  estoque: 'Estoque',
  monitoramento: 'Monitoramento',
  relatorios: 'Relatórios',
  painel: 'Painel',
  financeiro: 'Financeiro',
  roteiros: 'Roteiros',
  pv: 'Pedidos do cliente (PV)',
  precos: 'Preços',
  compras: 'Compras',
  expedicao: 'Expedição',
  certificado: 'Certificado',
  portal: 'Portal do cliente',
  recebimentos: 'Recebimentos (NF de entrada)',
  desenho: 'Desenhos técnicos',
};

export const ROTULOS_ACAO: Readonly<Record<string, string>> = {
  manage: 'Gerenciar usuários e perfis',
  create: 'Registrar apontamento',
  consultar: 'Consultar',
  operar: 'Operar',
  administrar: 'Administrar',
  corte: 'Executar o corte da migração',
  gerenciar: 'Gerenciar',
  receber: 'Receber',
  registrar: 'Registrar',
  aprovar: 'Aprovar',
  corrigir: 'Corrigir',
  'revisar-executado': 'Revisar etapa já executada',
  'ver-fiscal-completo': 'Ver dados fiscais completos',
  estornar: 'Estornar',
  ler: 'Consultar',
  editar: 'Editar',
  ajustar: 'Ajustar',
  fechar: 'Fechar',
  movimentar: 'Movimentar',
  inventariar: 'Inventariar',
  'aprovar-ajuste': 'Aprovar ajuste',
  configurar: 'Configurar',
  'gerenciar-acessos': 'Gerenciar acessos',
  'confirmar-saida': 'Confirmar saída física',
  'solicitar-estorno': 'Solicitar correção de saída',
  'executar-estorno': 'Executar estorno',
  'aprovar-fiscal': 'Aprovar nota',
  'aprovar-financeiro': 'Aprovar parcelas',
  'assumir-pendencia': 'Assumir pendência',
  reenviar: 'Reenviar após conciliar',
  'aprovar-piloto': 'Aprovar cliente do piloto',
  solicitar: 'Solicitar abastecimento',
  separar: 'Separar material',
  entregar: 'Confirmar entrega',
  atualizar: 'Atualizar notas',
  classificar: 'Classificar nota',
  resolver: 'Resolver pendência',
  publicar: 'Publicar revisão',
};

export const DESCRICOES_PERMISSAO: Readonly<Record<string, string>> = {
  'users:manage': 'Cria e edita usuários, perfis e permissões, e atribui perfis às pessoas.',
  'apontamento:create': 'Registra apontamentos de produção no chão de fábrica (tablet e coletor).',
  'omie:consultar': 'Consulta clientes, pendências e o status das operações da integração com a Omie.',
  'omie:operar': 'Importa clientes e solicita operações de faturamento e conciliação na Omie.',
  'omie:administrar': 'Administra o piloto da integração Omie, com clientes liberados, aprovações e pausa global.',
  'migracao:consultar': 'Consulta o andamento e os relatórios da migração de dados do sistema anterior.',
  'migracao:operar': 'Executa importações e conferências da migração de dados.',
  'migracao:corte': 'Executa o corte definitivo da migração de dados.',
  'producao:consultar': 'Consulta ordens de produção, lotes e etapas sem alterá-los.',
  'producao:gerenciar': 'Cria e gerencia ordens de produção, divide lotes e controla os cartões de controle.',
  'planejamento:consultar': 'Consulta o planejamento: fila de produção, Gantt e situação das ordens de serviço.',
  'planejamento:gerenciar': 'Reordena a fila de produção e libera bloqueios de ordens de serviço com justificativa.',
  'kanban:gerenciar': 'Move, prioriza e bloqueia cartões no quadro Kanban da produção.',
  'qualidade:gerenciar': 'Gerencia não conformidades, inspeções e certificados de qualidade.',
  'remessas:gerenciar': 'Cria e gerencia remessas, lotes e ordens de produção ligadas às notas de entrada.',
  'remessas:receber': 'Confirma o recebimento físico das notas de entrada e gera remessa, lote e ordem de produção.',
  'remessas:ver-fiscal-completo': 'Baixa o XML fiscal bruto e vê todos os dados fiscais das notas.',
  'remessas:estornar': 'Estorna uma remessa já registrada, preservando o histórico.',
  'cadastros:consultar': 'Consulta clientes, materiais, serviços e demais cadastros.',
  'cadastros:gerenciar': 'Cria, edita e desativa clientes, materiais, serviços e demais cadastros.',
  'estoque:consultar': 'Consulta saldos, movimentações e posições de estoque.',
  'estoque:gerenciar': 'Registra e estorna movimentações de estoque.',
  'estoque:movimentar': 'Registra entradas, saídas e transferências de material entre locais e donos.',
  'estoque:inventariar': 'Abre inventários e registra contagens de estoque.',
  'estoque:aprovar-ajuste': 'Aprova ou rejeita ajustes de inventário.',
  'estoque:configurar': 'Configura locais, donos e parâmetros do estoque.',
  'monitoramento:consultar': 'Consulta os painéis de monitoramento da produção.',
  'monitoramento:registrar': 'Registra consumo, sobras e progresso, aceitando desvios sem bloqueio.',
  'relatorios:consultar': 'Consulta relatórios e indicadores, incluindo o Gate G7.',
  'relatorios:aprovar': 'Aprova formalmente o Gate G7 de um lote.',
  'apontamentos:registrar': 'Registra apontamentos pela gestão e acompanha o quadro dos tablets.',
  'apontamentos:corrigir': 'Corrige um apontamento por estorno integral e novo lançamento.',
  'painel:consultar': 'Vê os indicadores e atalhos do painel inicial.',
  'roteiros:revisar-executado': 'Revisa etapas de roteiro mesmo depois de executadas, gerando nova versão auditada.',
  'roteiros:gerenciar': 'Criar e versionar roteiros de peças, modelos de roteiro e importar do CargaMáquina.',
  'pv:ler': 'Consulta pedidos de venda, itens e situação.',
  'pv:editar': 'Cria e edita pedidos de venda e seus itens.',
  'pv:ajustar': 'Ajusta pedidos de venda já confirmados, com histórico.',
  'pv:fechar': 'Fecha pedidos de venda e conclui o atendimento.',
  'precos:gerenciar': 'Mantém as tabelas de preços e as regras de preço dos serviços.',
  'compras:consultar': 'Consulta pedidos de compra, notas e fornecedores.',
  'compras:gerenciar': 'Cria e gerencia pedidos de compra, notas e custos de compra.',
  'compras:receber': 'Recebe notas de compra e dá entrada do material no estoque.',
  'expedicao:consultar': 'Consulta reservas, coletas e romaneios sem alterar a saída física.',
  'expedicao:confirmar-saida': 'Confirma a saída física depois da conferência documental.',
  'expedicao:solicitar-estorno': 'Envia uma solicitação de correção para revisão autorizada.',
  'expedicao:executar-estorno': 'Executa o estorno aprovado e preserva a saída original.',
  'financeiro:consultar': 'Exibe valores, parcelas e vencimentos das propostas.',
  'financeiro:aprovar-fiscal': 'Aprova a proposta fiscal sem aprovar as parcelas.',
  'financeiro:aprovar-financeiro': 'Aprova parcelas de forma independente da nota fiscal.',
  'omie:assumir-pendencia': 'Assume uma pendência compartilhada para atendimento.',
  'omie:reenviar': 'Permite reenviar somente depois de conciliar e revalidar bloqueios.',
  'omie:aprovar-piloto': 'Registra a aprovação da gestão para um cliente do piloto Omie (dupla aprovação com o Admin).',
  'certificado:configurar': 'Mantém a configuração de certificado quando esse recurso estiver disponível.',
  'portal:configurar': 'Mantém a configuração de portal quando esse recurso estiver disponível.',
  'portal:gerenciar-acessos': 'Cria usuários do portal do cliente, gera links de acesso e desativa ou revoga acessos.',
  'estoque:solicitar': 'Pede material do almoxarifado para um lote ou setor da produção.',
  'estoque:ajustar': 'Ajusta quantidades de uma solicitação de abastecimento ainda não entregue.',
  'estoque:separar': 'Registra a separação do material solicitado no almoxarifado.',
  'estoque:entregar': 'Confirma a entrega do material separado ao lote ou setor.',
  'estoque:estornar': 'Estorna uma entrega de abastecimento já confirmada.',
  'recebimentos:consultar': 'Consulta a central de recebimentos de notas fiscais de entrada.',
  'recebimentos:atualizar': 'Dispara a sincronização manual das notas de entrada com a Omie.',
  'recebimentos:classificar': 'Classifica uma nota de entrada com justificativa auditada.',
  'recebimentos:resolver': 'Resolve pendência crítica de cancelamento de nota com justificativa.',
  'desenho:ler': 'Consulta desenhos técnicos e a revisão vigente usada no lote ou na OS.',
  'desenho:publicar': 'Cria e publica revisões de desenho e decide a revisão aplicada ao lote.',
  'remessas:consultar': 'Consulta pendências operacionais de remessas sem alterá-las.',
};

function separar(chave: string): { readonly modulo: string; readonly acao: string } {
  const posicao = chave.indexOf(':');
  if (posicao <= 0) return { modulo: chave, acao: '' };
  return { modulo: chave.slice(0, posicao), acao: chave.slice(posicao + 1) };
}

function capitalizar(valor: string): string {
  return valor.replace(/-/g, ' ').replace(/\b\w/g, (letra) => letra.toUpperCase());
}

export function rotuloModulo(modulo: string): string {
  return ROTULOS_MODULO[modulo] ?? capitalizar(modulo);
}

export function rotuloAcao(acao: string): string {
  return ROTULOS_ACAO[acao] ?? capitalizar(acao);
}

/** Descrição de uma frase; a chave completa decide (estoque:estornar difere de remessas:estornar). */
export function descricaoPermissao(chave: string): string {
  const explicita = DESCRICOES_PERMISSAO[chave];
  if (explicita) return explicita;
  const { modulo, acao } = separar(chave);
  return `Permite ${rotuloAcao(acao).toLocaleLowerCase('pt-BR')} em ${rotuloModulo(modulo)}.`;
}

export interface ItemPermissao {
  readonly chave: string;
  readonly modulo: string;
  readonly acao: string;
  readonly rotuloAcao: string;
  readonly descricao: string;
}

export interface GrupoPermissoes {
  readonly modulo: string;
  readonly rotulo: string;
  readonly itens: readonly ItemPermissao[];
}

/** Agrupa por módulo, ordena os grupos pelo rótulo pt-BR e deixa "Outras permissões" por último. */
export function agruparPorModulo(chaves: readonly string[]): readonly GrupoPermissoes[] {
  const grupos = new Map<string, ItemPermissao[]>();
  for (const chave of new Set(chaves)) {
    const { modulo, acao } = separar(chave);
    const destino = ROTULOS_MODULO[modulo] ? modulo : GRUPO_OUTRAS;
    const lista = grupos.get(destino) ?? [];
    lista.push({ chave, modulo, acao, rotuloAcao: rotuloAcao(acao), descricao: descricaoPermissao(chave) });
    grupos.set(destino, lista);
  }
  const resultado: GrupoPermissoes[] = [...grupos.entries()].map(([modulo, itens]) => ({
    modulo,
    rotulo: modulo === GRUPO_OUTRAS ? GRUPO_OUTRAS : rotuloModulo(modulo),
    itens: [...itens].sort((a, b) => a.chave.localeCompare(b.chave, 'pt-BR')),
  }));
  return resultado.sort((a, b) => {
    if (a.modulo === GRUPO_OUTRAS) return 1;
    if (b.modulo === GRUPO_OUTRAS) return -1;
    return a.rotulo.localeCompare(b.rotulo, 'pt-BR');
  });
}
